export default __webpack_public_path__ + "static/media/emoji_celebration.f96bdc0c.png";